import React from "react";
import { BadgeCheck, CheckCircle2, Clock, XCircle } from "lucide-react";
import { cn } from "../lib/utils";

const STATUS = {
  Pending: {
    cls: "bg-[hsl(var(--warning))]/15 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/30",
    Icon: Clock,
  },
  Approved: {
    cls: "bg-[hsl(var(--info))]/15 text-[hsl(var(--info))] border-[hsl(var(--info))]/30",
    Icon: CheckCircle2,
  },
  Rejected: {
    cls: "bg-destructive/15 text-destructive border-destructive/30",
    Icon: XCircle,
  },
  Completed: {
    cls: "bg-[hsl(var(--profit))]/15 text-[hsl(var(--profit))] border-[hsl(var(--profit))]/30",
    Icon: BadgeCheck,
  },
};

const base =
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap";

export const StatusBadge = ({ status, className }) => {
  const conf = STATUS[status] || STATUS.Pending;
  const { Icon } = conf;
  return (
    <span className={cn(base, conf.cls, className)} data-testid={`status-badge-${status}`}>
      <Icon className="h-3 w-3" />
      {status}
    </span>
  );
};

const LEVELS = {
  Bronze: "bg-[hsl(28_55%_45%)]/15 text-[hsl(28_55%_45%)] dark:text-[hsl(28_60%_62%)] border-[hsl(28_55%_55%)]/30",
  Silver: "bg-[hsl(210_10%_60%)]/15 text-[hsl(210_10%_38%)] dark:text-[hsl(210_12%_80%)] border-[hsl(210_10%_70%)]/30",
  Gold: "bg-[hsl(45_90%_50%)]/15 text-[hsl(40_85%_38%)] dark:text-[hsl(45_90%_60%)] border-[hsl(45_90%_55%)]/30",
  Platinum: "bg-[hsl(190_25%_60%)]/15 text-[hsl(190_30%_32%)] dark:text-[hsl(190_30%_78%)] border-[hsl(190_25%_70%)]/30",
  Diamond: "bg-[hsl(205_78%_50%)]/15 text-[hsl(205_78%_38%)] dark:text-[hsl(205_80%_66%)] border-[hsl(205_78%_56%)]/30",
};

export const LevelBadge = ({ level, className }) => (
  <span
    className={cn(base, LEVELS[level] || LEVELS.Bronze, className)}
    data-testid={`level-badge-${level}`}
  >
    {level || "Bronze"}
  </span>
);

const BADGES = {
  Verified: "bg-primary/15 text-primary border-primary/30",
  Gold: "bg-[hsl(45_90%_50%)]/15 text-[hsl(40_85%_38%)] dark:text-[hsl(45_90%_60%)] border-[hsl(45_90%_55%)]/30",
  Platinum: "bg-[hsl(210_10%_60%)]/15 text-[hsl(210_10%_38%)] dark:text-[hsl(210_12%_80%)] border-[hsl(210_10%_75%)]/30",
  VIP: "bg-[hsl(262_52%_55%)]/15 text-[hsl(262_52%_45%)] dark:text-[hsl(262_60%_74%)] border-[hsl(262_52%_62%)]/30",
  "Top Investor": "bg-[hsl(205_78%_50%)]/15 text-[hsl(205_78%_38%)] dark:text-[hsl(205_80%_66%)] border-[hsl(205_78%_56%)]/30",
  "Long Term": "bg-secondary text-secondary-foreground border-border",
};

export const ClientBadge = ({ label, className }) => (
  <span
    className={cn(base, BADGES[label] || BADGES["Long Term"], className)}
    data-testid={`client-badge-${label}`}
  >
    {label === "Verified" && <BadgeCheck className="h-3 w-3" />}
    {label}
  </span>
);
